export default __webpack_public_path__ + "static/14_23-c610e186a696c689111406298aadcad1.png";